import { Grid, Paper } from "@mui/material";
import Box from "@mui/material/Box";
import axios, { AxiosRequestConfig } from "axios";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import AlertField from "../../../components/Alert";
import { TextInput } from "../../../components/Input";
import { MaskInput } from "../../../components/MaskInput";
import { PrimaryButton } from "../../../components/PrimaryButton";
import { AppContext } from "../../../context";

export const EwqAddressForm = () => {
  const { updateLead, lead, setLoading, theme } = useContext<any>(AppContext);
  const [street, setStreet] = useState("");
  const [city, setCity] = useState("");
  const [neighborhood, setNeighborhood] = useState("");
  const [state, setState] = useState("");
  const history = useHistory();
  const [openAlert, setOpenAlert] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    updateValue();
  }, []);

  const updateValue = () => {
    setStreet(lead.address_street);
    setCity(lead.address_city);
    setNeighborhood(lead.address_neighborhood);
    setState(lead.address_state);
  };
  const handleCep = async (e: any) => {
    const cep = e.replace(/\D/g, "");
    if (cep.length === 8) {
      const url = `https://brasilapi.com.br/api/cep/v2/${cep}`;
      const config: AxiosRequestConfig = {
        method: "POST",
        url: url,
      };
      setLoading(true);
      try {
        const res = await axios(config);
        setLoading(false);
        console.log(res.data);
        if (res.data.street) {
          setStreet(res.data.street);
        }
        if (res.data.city) {
          setCity(res.data.city);
        }
        if (res.data.neighborhood) {
          setNeighborhood(res.data.neighborhood);
        }
        if (res.data.state) {
          setState(res.data.state);
        }
      } catch (e: any) {
        setLoading(false);
        console.log(e);
      }
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpenAlert(false);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    const data = {
      address_cep: e.target.cep.value.replace(/\D/g, ""),
      address_street: street,
      address_number: e.target.number.value,
      address_complement: e.target.complement.value,
      address_neighborhood: e.target.neighborhood.value,
      address_city: e.target.city.value,
      address_state: e.target.state.value,
    };
    console.log(data);
    if (!data.address_cep) {
      setAlertMessage("CEP não informado!");
      setOpenAlert(true);
    } else if (!data.address_street) {
      setAlertMessage("Endereço não informado!");
      setOpenAlert(true);
    } else if (!data.address_number) {
      setAlertMessage("Número não informado!");
      setOpenAlert(true);
    } else if (!data.address_neighborhood) {
      setAlertMessage("Bairro não informado!");
      setOpenAlert(true);
    } else if (!data.address_city) {
      setAlertMessage("Cidade não informado!");
      setOpenAlert(true);
    } else if (!data.address_state) {
      setAlertMessage("Unidade Federativa não informada!");
      setOpenAlert(true);
    } else {
      const res = await updateLead(data);
      if (res) {
        history.push("/ewq/revisao");
      }
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "background.default",
      }}
    >
      <Paper
        variant="outlined"
        elevation={2}
        sx={{
          backgroundColor: "background.default",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: "flex", alignItems: "flex-end" }}>
            <AlertField
              message={alertMessage}
              status={openAlert}
              handle={handleClose}
            />
          </Box>
          <Grid
            container
            sx={{ px: 4, py: 3, maxWidth: 900 }}
            rowSpacing={1}
            spacing={3}
          >
            <Grid item xs={12} sm={4}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <MaskInput
                  defaultValue={lead.address_cep}
                  mask="99.999-999"
                  id="cep"
                  label="CEP"
                  handle={handleCep}
                  value={lead.address_cep}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <TextInput
                  defaultValue={lead.address_street}
                  id="street"
                  label="Endereço"
                  value={street}
                  handle={setStreet}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <TextInput
                  defaultValue={lead.address_number}
                  id="number"
                  label="Número"
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <TextInput
                  defaultValue={lead.address_complement}
                  id="complement"
                  label="Complemento"
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <TextInput
                  defaultValue={lead.address_neighborhood}
                  id="neighborhood"
                  label="Bairro"
                  value={neighborhood}
                  handle={setNeighborhood}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <TextInput
                  defaultValue={lead.address_city}
                  id="city"
                  label="Cidade"
                  value={city}
                  handle={setCity}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <TextInput
                  defaultValue={lead.address_state}
                  id="state"
                  label="UF"
                  value={state}
                  handle={setState}
                />
              </Box>
            </Grid>
          </Grid>
          <Box sx={{ display: "flex", alignItems: "flex-end", mt: 2 }}>
            <PrimaryButton name="Prosseguir" />
          </Box>
        </form>
      </Paper>
    </Box>
  );
};
